'use client';

import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import { DesktopPageShell } from '@/components/template/DesktopPageShell';
import type { PolicyFilterState, PolicySortOption } from '../../_hooks/usePolicyFilter';
import { EMPTY_AI_SUMMARY_MESSAGE, PAGE_SIZE } from '../../constants';
import { buildPaginationMeta, formatApplicationPeriod } from '../../utils';
import { PolicyFilter } from './PolicyFilter';
import { PolicyResultList } from './PolicyResultList';
interface PolicySearchProps {
  isFilterOpen: boolean;
  onCloseFilter: () => void;
  state: PolicyFilterState;
  onToggleTargetCode: (code: string) => void;
  onToggleProvisionCode: (code: string) => void;
  onToggleJobCode: (code: string) => void;
  onToggleAgeCode: (code: string) => void;
  onToggleIncludeExpired: () => void;
  onResetFilters: () => void;
  onSortChange: (sort: PolicySortOption) => void;
  onPageChange: (page: number) => void;
}
export function PolicySearch(t0) {
  const $ = _c(39);
  const {
    isFilterOpen,
    onCloseFilter,
    state,
    onToggleTargetCode,
    onToggleProvisionCode,
    onToggleJobCode,
    onToggleAgeCode,
    onToggleIncludeExpired,
    onResetFilters,
    onSortChange,
    onPageChange
  } = t0;
  let t1;
  if ($[0] !== state.ageCodes || $[1] !== state.includeExpired || $[2] !== state.jobCodes || $[3] !== state.keyword || $[4] !== state.page || $[5] !== state.provisionCodes || $[6] !== state.sort || $[7] !== state.targetCodes) {
    t1 = UnauthQueryOptions["get:/wello/v2/allows/query/policies"]({
      query: {
        searchKeyword: state.keyword || undefined,
        targetCodeList: state.targetCodes.length > 0 ? state.targetCodes : undefined,
        provisionCodeList: state.provisionCodes.length > 0 ? state.provisionCodes : undefined,
        jobCodeList: state.jobCodes.length > 0 ? state.jobCodes : undefined,
        descAgeList: state.ageCodes.length > 0 ? state.ageCodes : undefined,
        policySort: state.sort,
        page: state.page,
        size: PAGE_SIZE,
        expiredPolicyExcludeYN: state.includeExpired ? false : undefined
      }
    });
    $[0] = state.ageCodes;
    $[1] = state.includeExpired;
    $[2] = state.jobCodes;
    $[3] = state.keyword;
    $[4] = state.page;
    $[5] = state.provisionCodes;
    $[6] = state.sort;
    $[7] = state.targetCodes;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== t1) {
    t2 = {
      ...t1,
      placeholderData: keepPreviousData,
      select: _temp2
    };
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const {
    data: policyData,
    isLoading: isPolicyLoading
  } = useQuery(t2);
  let t3;
  if ($[11] !== isFilterOpen || $[12] !== onCloseFilter || $[13] !== onResetFilters || $[14] !== onToggleAgeCode || $[15] !== onToggleIncludeExpired || $[16] !== onToggleJobCode || $[17] !== onToggleProvisionCode || $[18] !== onToggleTargetCode || $[19] !== state.ageCodes || $[20] !== state.includeExpired || $[21] !== state.jobCodes || $[22] !== state.provisionCodes || $[23] !== state.targetCodes) {
    t3 = <PolicyFilter isDrawerOpen={isFilterOpen} onCloseDrawer={onCloseFilter} onApplyDrawer={onCloseFilter} targetCodes={state.targetCodes} provisionCodes={state.provisionCodes} jobCodes={state.jobCodes} ageCodes={state.ageCodes} includeExpired={state.includeExpired} onToggleIncludeExpired={onToggleIncludeExpired} onToggleTargetCode={onToggleTargetCode} onToggleProvisionCode={onToggleProvisionCode} onToggleJobCode={onToggleJobCode} onToggleAgeCode={onToggleAgeCode} onReset={onResetFilters} />;
    $[11] = isFilterOpen;
    $[12] = onCloseFilter;
    $[13] = onResetFilters;
    $[14] = onToggleAgeCode;
    $[15] = onToggleIncludeExpired;
    $[16] = onToggleJobCode;
    $[17] = onToggleProvisionCode;
    $[18] = onToggleTargetCode;
    $[19] = state.ageCodes;
    $[20] = state.includeExpired;
    $[21] = state.jobCodes;
    $[22] = state.provisionCodes;
    $[23] = state.targetCodes;
    $[24] = t3;
  } else {
    t3 = $[24];
  }
  let t4;
  if ($[25] !== policyData?.policies) {
    t4 = policyData?.policies ?? [];
    $[25] = policyData?.policies;
    $[26] = t4;
  } else {
    t4 = $[26];
  }
  const t5 = policyData?.totalCount ?? 0;
  const t6 = policyData?.totalPages ?? 0;
  let t7;
  if ($[27] !== isPolicyLoading || $[28] !== onPageChange || $[29] !== onSortChange || $[30] !== state.page || $[31] !== state.sort || $[32] !== t4 || $[33] !== t5 || $[34] !== t6) {
    t7 = <PolicyResultList policies={t4} totalCount={t5} sort={state.sort} onSortChange={onSortChange} page={state.page} totalPages={t6} onPageChange={onPageChange} isLoading={isPolicyLoading} emptyMessage={"\uC870\uAC74\uC5D0 \uB9DE\uB294 \uC815\uCC45\uC774 \uC5C6\uC2B5\uB2C8\uB2E4"} />;
    $[27] = isPolicyLoading;
    $[28] = onPageChange;
    $[29] = onSortChange;
    $[30] = state.page;
    $[31] = state.sort;
    $[32] = t4;
    $[33] = t5;
    $[34] = t6;
    $[35] = t7;
  } else {
    t7 = $[35];
  }
  let t8;
  if ($[36] !== t3 || $[37] !== t7) {
    t8 = <DesktopPageShell className="mt-20 w-full mobile-tablet:mt-0" leftAside={t3}>{t7}</DesktopPageShell>;
    $[36] = t3;
    $[37] = t7;
    $[38] = t8;
  } else {
    t8 = $[38];
  }
  return t8;
}
function _temp2(data) {
  const context = data.context;
  return {
    policies: context?.contents?.map(_temp) ?? [],
    ...buildPaginationMeta(context?.totalCount)
  };
}
function _temp(policy) {
  return {
    id: policy.metaPolicyIdIdx ?? String(policy.id ?? ""),
    slugId: policy.slugId,
    contentId: policy.id,
    title: policy.policyName ?? "",
    aiSummary: policy.aiSummary ?? EMPTY_AI_SUMMARY_MESSAGE,
    applicationPeriod: formatApplicationPeriod(policy.dueDateStart, policy.dueDateEnd),
    agencyName: policy.agency ?? "",
    agencyLogo: policy.agencyLogo ?? "",
    isBookmarked: Boolean(policy.wishlistYN)
  };
}